
    import './styles.scoped.css';
    export default {
  "button-trigger": "awsui_button-trigger_18eso_1sg0d_17",
  "arrow": "awsui_arrow_18eso_1sg0d_17",
  "in-filtering-token-root": "awsui_in-filtering-token-root_18eso_1sg0d_77",
  "in-filtering-token-nested": "awsui_in-filtering-token-nested_18eso_1sg0d_77",
  "has-caret": "awsui_has-caret_18eso_1sg0d_113",
  "placeholder": "awsui_placeholder_18eso_1sg0d_116",
  "pressed": "awsui_pressed_18eso_1sg0d_132",
  "disabled": "awsui_disabled_18eso_1sg0d_138",
  "in-filtering-token": "awsui_in-filtering-token_18eso_1sg0d_77",
  "readonly": "awsui_readonly_18eso_1sg0d_159",
  "compact": "awsui_compact_18eso_1sg0d_171",
  "grouped-with-error": "awsui_grouped-with-error_18eso_1sg0d_171",
  "grouped-with-warning": "awsui_grouped-with-warning_18eso_1sg0d_171",
  "invalid": "awsui_invalid_18eso_1sg0d_180",
  "warning": "awsui_warning_18eso_1sg0d_189",
  "custom-option": "awsui_custom-option_18eso_1sg0d_204",
  "inline-tokens": "awsui_inline-tokens_18eso_1sg0d_209",
  "grouped": "awsui_grouped_18eso_1sg0d_171",
  "grouped-horizontal-first": "awsui_grouped-horizontal-first_18eso_1sg0d_258",
  "grouped-horizontal-middle": "awsui_grouped-horizontal-middle_18eso_1sg0d_262",
  "grouped-horizontal-last": "awsui_grouped-horizontal-last_18eso_1sg0d_268",
  "grouped-vertical-first": "awsui_grouped-vertical-first_18eso_1sg0d_272",
  "grouped-vertical-middle": "awsui_grouped-vertical-middle_18eso_1sg0d_276",
  "grouped-vertical-last": "awsui_grouped-vertical-last_18eso_1sg0d_282",
  "grouped-with-action": "awsui_grouped-with-action_18eso_1sg0d_286",
  "grouped-horizontal-only": "awsui_grouped-horizontal-only_18eso_1sg0d_318",
  "grouped-vertical-only": "awsui_grouped-vertical-only_18eso_1sg0d_318",
  "grouped-row-first": "awsui_grouped-row-first_18eso_1sg0d_358"
};
  